import { BUG_SNAG_MI_TRADE_API_KEY } from "@miplatform/constants";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

Bugsnag.start({
  apiKey: BUG_SNAG_MI_TRADE_API_KEY,
  plugins: [new BugsnagPluginReact()],
  async onError(event) {
    if (process.env.NODE_ENV === "development") {
      console.log(`${event?.context}-> ${event.originalError.message}`);
      event.addMetadata("development", {
        type: "dev-error",
      });
    }
  },
  logger: null,
});

// NOTE: Avoid leaking a private `@bugsnag/js` type into generated `.d.ts`.
/** @type {any} */
export const bugsnag = Bugsnag;
